import MultiDropdown from '@/shared/Inputs/MultiDropdownInput'
import systemEventsTypeConstants from './systemEventsType.constans.ts'
import { CSSProperties } from 'react'
import { ISystemEvent } from '../../systemEvents.types.ts'

interface IProps {
  statuses: Array<ISystemEvent['type']>
  onChange: (statutes: ISystemEvent['type'][], name: string) => void
  name?: string
  panelStyle?: CSSProperties
}

const SystemEventsTypeDropdown = (props: IProps) => {
  return (
    <MultiDropdown
      name={props.name}
      selectedOptions={props.statuses as Array<string>}
      title="Тип"
      options={systemEventsTypeConstants.fieldTypeOptions}
      type="filter"
      panelStyle={{ width: '230px', ...props.panelStyle }}
      onSelect={props.onChange}
    />
  )
}

export default SystemEventsTypeDropdown
